/* eslint-disable no-console */
import React, {useEffect, useState} from 'react'
import {FieldValues, useForm} from 'react-hook-form'
import {useNavigate} from 'react-router-dom'
// import {toast} from 'react-toastify'
import Spinner from 'layout/common/Spinner'
import {Button} from 'helpers/ui-components/Button'
import {useTranslation} from 'react-i18next'
import {Model} from 'helpers'
import {OTPField} from 'helpers/ui-components/form/OTPField'
import {Select2DropdownField} from 'helpers/ui-components/form/Select2DropdownField'
import {
 fetchStackholders,
 fetchStackholderCategory,
 fetchUserCategory,
 fetchOnboardingItmesConfig,
 submitOnboardingItmes,
 generateOTP,
 verifyOTP,
} from 'utils/api/auth/registerService'
import IDropdown, {
 OrganizationTypeList,
} from 'models/dropdown'
import GenericFormBuilder from 'helpers/ui-components/GenericFormBuilder'
import {
 IFileObject,
 IFormData,
 IFormField,
} from 'models/Common'
import {IItmeConfig, IItmesConfig} from 'models/GenericForm'
import {toast} from 'react-toastify'
import {
 createOrganisationApi,
 updateOrganisationApi,
} from 'utils/api/auth/organisationService'
import OrganisationFormFields from 'module/activity-management/view-organisation/OrganisationFormFields'
import {
 CreateOrganisationPayload,
 FormDataType,
} from 'models/ViewOrganisation'
import OrganisationPreviewModal from './OrganisationPreviewModal'
import {fetchOrganisationTypes} from 'utils/api/auth/userManagementService'

const RegisterForm = () => {
 const {t} = useTranslation()
 const navigate = useNavigate()
 const [loader, setLoader] = useState(false)
 const isDisabled = true
 const [otpModel, setOTPModel] = useState(false)
 const [isOrgCreated, setIsOrgCreated] = useState(false)
 const [uploadedFileData, setUploadedFileData] =
  useState<IFileObject>({})
 const [registerFormData, setRegisterFormData] =
  useState<IFormData>({})
 const [isOrgEdit, setIsOrgEdit] = useState(false)
 const [isOrgEditing, setIsOrgEditing] = useState(false)
 const [orgFormData, setOrgFormData] =
  useState<FormDataType>({
   name: '',
   type: '',
   state: null,
   district: null,
   subDistrict: null,
   state_name: '',
   district_name: '',
   subDistrict_name: '',
   pan_number: '',
   gst_number: '',
   territory: null,
   territory_name: '',
   commercial_area: null,
   commercial_area_name: '',
   pincode: '',
   full_address: '',
  })
 const [showOrgModal, setShowOrgModal] = useState(false)
 const [showPreviewModal, setShowPreviewModal] =
  useState(false)
 const [savedOrgData, setSavedOrgData] =
  useState<FormDataType | null>(null)
 const [selectedOrgField, setSelectedOrgField] =
  useState('')
 const [stackholderList, setStackholderList] = useState<
  IDropdown[]
 >([])
 const [
  stackholderCategoryList,
  setStackholderCategoryList,
 ] = useState<IDropdown[]>([])
 const [userCategoryList, setUserCategoryList] = useState<
  IDropdown[]
 >([])
 const [itemConfigList, setItemConfigList] = useState<
  IItmesConfig[]
 >([])
 const registerForm = {
  stakeholder: '',
  category: '',
  user_category: '',
  whatsapp_notif_enabled: '',
  country: 'ind',
 }
 const {
  register,
  control,
  getValues,
  watch,
  setValue,
  reset,
  handleSubmit,
  formState: {errors},
 } = useForm<FieldValues>({
  mode: 'all',
  reValidateMode: 'onChange',
  defaultValues: {...registerForm},
 })

 const otpForm = {
  verificationCode: '',
 }
 const {
  register: register1,
  handleSubmit: handleSubmit1,
  setFocus: setFocus1,
  formState: {errors: errors1, isValid: isValid1},
 } = useForm({
  mode: 'all',
  reValidateMode: 'onChange',
  defaultValues: {...otpForm},
 })

 const getStackholderCategory = async (
  stackholderId: number
 ) => {
  setLoader(true)
  setValue('category', '')
  setValue('user_category', '')
  setStackholderCategoryList([])
  setUserCategoryList([])
  setItemConfigList([])
  const res: IDropdown[] = await fetchStackholderCategory(
   stackholderId
  )
  if (res) {
   setStackholderCategoryList(res)
  }
  setLoader(false)
 }
 const mapOrgPayload = (
  data: FormDataType
 ): CreateOrganisationPayload => {
  return {
   name: data.name,
   type: data.type,
   category: data.type,
   state: data.state,
   district: data.district,

   sub_district: data.subDistrict,
   commercial_area: data.commercial_area,
   territory: data.territory,

   pan_number: data.pan_number,
   gstin_number: data.gst_number,

   pin_code: data.pincode,
   full_address: data.full_address,
  }
 }

 const handleCreateOrganisation = async (
  data: FormDataType
 ) => {
  try {
   setLoader(true)

   const payload = mapOrgPayload(data)

   const types = (await fetchOrganisationTypes({
    distributor_needed: true,
   })) as OrganizationTypeList[]
   const value =
    payload.category?.trim().toUpperCase() || ''
   const matchedType = types.find(
    (item) =>
     item.key?.trim().toUpperCase() === value ||
     item.display_name?.trim().toUpperCase() === value
   )
   const resolvedType = matchedType?.key || ''

   if (!resolvedType) {
    toast.error('Organisation type is required')
    setLoader(false)
    return
   }

   payload.type = resolvedType
   payload.category = resolvedType
   const typeDisplayName = matchedType?.display_name || ''

   const panRegex = /^[A-Z]{3}[CF][A-Z][0-9]{4}[A-Z]{1}$/

   if (!payload.pan_number) {
    toast.error('PAN Number is required')
    setLoader(false)
    return
   }

   const pan = payload.pan_number.trim().toUpperCase()

   if (!panRegex.test(pan)) {
    toast.error(
     t('organisation.organisationForm.invalidPanNumber')
    )
    setLoader(false)
    return
   }

   payload.pan_number = pan

   let res

   if (isOrgEdit && data.id) {
    res = await updateOrganisationApi({
     org_id: data.id,
     ...payload,
    })
   } else {
    res = await createOrganisationApi(payload)
   }

   const org = res?.data

   if (org) {
    setSavedOrgData({
     ...data,
     type: resolvedType,
     type_name: typeDisplayName,
     id: org.id,
    })

    setIsOrgEdit(false)
    setIsOrgEditing(false)
   }

   if (!org?.id) return

   if (selectedOrgField) {
    setValue(selectedOrgField, org.id)
   }

   setIsOrgCreated(true)

   setItemConfigList((prev) => {
    return prev.map((item) => ({
     ...item,
     fields: item.fields.map((field) => {
      if (field.label_key === selectedOrgField) {
       return {
        ...field,
        custom_data: [...(field.custom_data || []), org],
       }
      }
      return field
     }),
    }))
   })

   toast.success(
    isOrgEdit
     ? 'Organisation updated successfully'
     : 'Organisation created successfully'
   )

   setShowOrgModal(false)
  } catch (e) {
   toast.error('Something went wrong')
  } finally {
   setLoader(false)
  }
 }

 const getUserCategory = async (categoryId: number) => {
  setLoader(true)
  setValue('user_category', '')
  setUserCategoryList([])
  setItemConfigList([])
  const stackholderId = parseInt(getValues('stakeholder'))
  const res: IDropdown[] = await fetchUserCategory(
   stackholderId,
   categoryId
  )
  if (res) {
   setUserCategoryList(res)
  }
  setLoader(false)
 }

 const getOnboardingItmesConfig = async (
  userCategoryId: number,
  parentId: number
 ) => {
  const res: IItmesConfig[] =
   await fetchOnboardingItmesConfig(
    userCategoryId,
    parentId
   )
  return res
 }

 const resetForm = async () => {
  setStackholderCategoryList([])
  setUserCategoryList([])
  setItemConfigList([])
  reset()
 }

 const setOnboardingItmes = async (
  userCategoryId: number
 ) => {
  setLoader(true)
  setItemConfigList([])
  const parentRes: IItmesConfig[] | undefined =
   await getOnboardingItmesConfig(userCategoryId, 0)
  if (parentRes) {
   parentRes.map(async (val: IItmesConfig) => {
    if (val?.item_identifier === 'basic_profile') {
     const childRes: IItmesConfig[] | undefined =
      await getOnboardingItmesConfig(userCategoryId, val.id)
     if (childRes) {
      setItemConfigList(childRes)
     }
    }
   })
  }
  setLoader(false)
 }

 const sendOTP = async (phone_number?: string) => {
  const res = await generateOTP({
   phone_number: phone_number
    ? phone_number
    : registerFormData.phone_number,
   refernce: 'mobile_verification_otp',
  })
  if (res) {
   toast.success(res)
  }
  return res
 }

 async function submitFormData(formData: IFormData) {
  setRegisterFormData({...formData})
  const res = await sendOTP(
   formData.phone_number?.toString()
  )
  if (res) {
   setOTPModel(true)
  }
 }

 async function submitOTPFormData(formData: IFormField) {
  setLoader(true)
  console.log('otpformData', formData)
  const verifyOtpRes = await verifyOTP({
   phone_number: registerFormData.phone_number,
   refernce: 'mobile_verification_otp',
   otp: formData?.otp?.join(''),
  })
  if (verifyOtpRes) {
   setOTPModel(false)
   toast.success(verifyOtpRes)
   const onBoardingItems: IItmeConfig[] = []
   for (const data of itemConfigList) {
    const fields: IFormData = {}
    for (const field of data.fields) {
     let value
     const labelKey = field.label_key
     if (field.field_type === 'TOGGLE_FIELD') {
      value = registerFormData?.[labelKey]?.toString()
     } else if (field.field_type === 'IMAGE_FIELD') {
      value = uploadedFileData?.[labelKey]?.filePath
     } else if (field.field_type === 'FILE_FIELD') {
      value = uploadedFileData?.[labelKey]?.filePath
     } else {
      value = registerFormData?.[labelKey]
     }

     fields[labelKey] = value
    }

    onBoardingItems.push({
     id: data.id,
     user_category: data.user_category,
     item_identifier: data.item_identifier,
     fields,
    })
   }
   const payload = {
    onboarding_items: onBoardingItems,
    ...(isOrgCreated && {org_creator: 'true'}),
   }

   const res = await submitOnboardingItmes(payload)
   if (res) {
    navigate('/thank-you')
   }
  }
  setLoader(false)
 }

 useEffect(() => {
  const getStackholders = async () => {
   setLoader(true)
   const res: IDropdown[] = await fetchStackholders()
   if (res) {
    setStackholderList(res)
   }
   setLoader(false)
  }
  void getStackholders()
 }, [])

 return (
  <>
   {loader && <Spinner />}
   <Model
    show={otpModel}
    showHeader={false}
    closeBtnClass='absolute right-4 top-2 !bg-[#E6EBF0] !rounded-3xl w-7 h-7 !text-[#33393D]'
    header={''}
    close={() => {
     setOTPModel(false)
    }}
    modelClass='md:w-[540px]'
    modelContainerClass='!rounded-2xl'
    modelBodyClass='p-10'
   >
    <div className='w-full'>
     <form
      method='POST'
      action=''
      onSubmit={handleSubmit1(submitOTPFormData)}
     >
      <div className='w-full'>
       <p className='text-[#171B1F] text-left font-bold text-2xl text-center'>
        {t('registerPage.otpModelTitle')}
       </p>
       <div className='w-full my-6'>
        <div className='my-8 text-left text-base font-medium'>
         <span className='text-[#171B1F]'>
          {t('otpPage.msgSent')}{' '}
          {`"******${registerFormData?.phone_number
           ?.toString()
           ?.substr(
            registerFormData.phone_number?.toString()
             ?.length - 4
           )}"`}
         </span>
        </div>
        <OTPField
         maxLength={1}
         label={''}
         helperText={''}
         required={true}
         labelClassName='text-[#4E83E4] text-xs font-medium mb-2'
         className='w-[54px] h-[60px] relative !py-3 text-center !px-4 rounded-lg border border-[#33393D] text-[#171B1F] !text-2xl !px-0 !font-medium block items-center'
         wrapperClassName='relative w-full'
         containerClass='!flex  gap-2 mt-2'
         register={register1}
         validation={{
          validate: {
           regex: (v: string) => {
            if (v !== '' && !v?.match('^[0-9]{1}$'))
             return ``
           },
           required: (v: string) => {
            if (v === '') return ``
           },
          },
         }}
         placeholder='_'
         type={'text'}
         name={'otp'}
         length={6}
         errorText={`${t('helperText.plsEnter')} ${t(
          'otpPage.otpErrorMsg'
         )}`}
         errors={errors1}
         setFocus={setFocus1}
        />
       </div>
       <div className='md:flex items-center justify-center'>
        <Button
         disabled={!isValid1}
         type='submit'
         color='blue'
         className='text-center w-full py-[9px] px-[24px] bg-[#4E83E4] 
                  !rounded-lg !text-base text-white font-semibold'
        >
         {t('otpPage.continue')}
        </Button>
       </div>
       <div className='my-4 text-center text-lg font-normal'>
        <span className='text-[#808080]'>
         {t('otpPage.didNotReceiveCode')}?{' '}
        </span>
        <button
         type='button'
         className='text-[#4E83E4]'
         onClick={() => {
          void sendOTP()
         }}
        >
         {t('otpPage.resend')}
        </button>
       </div>
      </div>
     </form>
    </div>
   </Model>
   <div className='container bg-white px-[72px] pb-16'>
    <form
     method='POST'
     action=''
     onSubmit={handleSubmit(submitFormData)}
    >
     <div className='w-full my-6 '>
      <div className='text-[#171B1F] text-xl font-bold border-[#E6EBF0] border-b pb-2'>
       {t('registerPage.title')}
       <p className='text-[#5A6066] text-xs font-normal pt-1'>
        {t('registerPage.subTitle')}
       </p>
      </div>
      <div className='text-[#2F2F2F] text-2xl font-medium my-8'>
       {t('myAccountPage.officialInformation.title')}
      </div>
      <div className='grid md:grid-cols-3 gap-5 w-full mt-4 text-[#171B1F]'>
       <Select2DropdownField
        label={t('registerPage.stakeholder')}
        labelClassName='padding-0 text-[#4E83E4] text-xs !font-medium'
        className={`${
         isDisabled
          ? '!text-[#33393D] font-medium '
          : 'font-normal !text-[#33393D]'
        } boxed-select2 relative block text-lg border-0  !rounded-l-lg`}
        wrapperClassName='relative w-full'
        inputWrapperClassName='pl-4 py-2 px-4 '
        required={true}
        disabled={false}
        isClearable={false}
        isSearchable={true}
        control={control}
        customStyle={{
         transition: 'unset',
         boxShadow: 'unset',
         border: '0px',
         borderRadius: '0px',
         padding: '0px 0px 0px 0px',
         minHeight: 'auto',
        }}
        data={stackholderList}
        rules={{
         validate: {
          required: (v: string) => {
           if (v === '')
            return `${t('helperText.plsSelect')} ${t(
             'registerPage.stakeholder'
            )}`
          },
         },
         onChange: (e: {target: {value: number}}) => {
          void getStackholderCategory(e.target.value)
         },
        }}
        id={`stakeholder`}
        name={`stakeholder`}
        OptionValueKey='id'
        OptionLabelKey='name'
        placeholder={`${t('helperText.select')} ${t(
         'registerPage.stakeholder'
        )}`}
        errors={errors}
       />
       <Select2DropdownField
        label={t('registerPage.category')}
        labelClassName='padding-0 text-[#4E83E4] text-xs !font-medium'
        className={`${
         isDisabled
          ? '!text-[#33393D] font-medium '
          : 'font-normal !text-[#33393D]'
        } boxed-select2 relative block text-lg border-0  !rounded-l-lg`}
        wrapperClassName='relative w-full'
        inputWrapperClassName='pl-4 py-2 px-4 '
        required={true}
        disabled={false}
        isClearable={false}
        isSearchable={true}
        control={control}
        customStyle={{
         transition: 'unset',
         boxShadow: 'unset',
         border: '0px',
         borderRadius: '0px',
         padding: '0px 0px 0px 0px',
         minHeight: 'auto',
        }}
        data={stackholderCategoryList}
        rules={{
         validate: {
          required: (v: string) => {
           if (v === '')
            return `${t('helperText.plsSelect')} ${t(
             'registerPage.category'
            )}`
          },
         },
         onChange: (e: {target: {value: number}}) => {
          void getUserCategory(e.target.value)
         },
        }}
        id={`category`}
        name={`category`}
        OptionValueKey='id'
        OptionLabelKey='name'
        placeholder={`${t('helperText.select')} ${t(
         'registerPage.category'
        )}`}
        errors={errors}
       />
       <Select2DropdownField
        label={t('registerPage.userCategory')}
        labelClassName='padding-0 text-[#4E83E4] text-xs !font-medium'
        className={`${
         isDisabled
          ? '!text-[#33393D] font-medium '
          : 'font-normal !text-[#33393D]'
        } boxed-select2 relative block text-lg border-0  !rounded-l-lg`}
        wrapperClassName='relative w-full'
        inputWrapperClassName='pl-4 py-2 px-4 '
        required={true}
        disabled={false}
        isClearable={false}
        isSearchable={true}
        control={control}
        customStyle={{
         transition: 'unset',
         boxShadow: 'unset',
         border: '0px',
         borderRadius: '0px',
         padding: '0px 0px 0px 0px',
         minHeight: 'auto',
        }}
        data={userCategoryList}
        rules={{
         validate: {
          required: (v: string) => {
           if (v === '')
            return `${t('helperText.plsSelect')} ${t(
             'registerPage.userCategory'
            )}`
          },
         },
         onChange: (e: {target: {value: number}}) => {
          void setOnboardingItmes(e.target.value)
         },
        }}
        id={`user_category`}
        name={`user_category`}
        OptionValueKey='id'
        OptionLabelKey='name'
        placeholder={`${t('helperText.select')} ${t(
         'registerPage.userCategory'
        )}`}
        errors={errors}
       />
       {itemConfigList.length > 0 && (
        <GenericFormBuilder
         itemConfigList={itemConfigList}
         excludedFields={[
          'stakeholder',
          'category',
          'user_category',
         ]}
         parentId={''}
         itemIdentifier={'official_information'}
         uploadedFileData={uploadedFileData}
         setUploadedFileData={setUploadedFileData}
         setLoader={setLoader}
         register={register}
         control={control}
         getValues={getValues}
         errors={errors}
         watch={watch}
         setValue={setValue}
         onOrganisationSelect={async (
          fieldId: React.SetStateAction<string>,
          _value: IDropdown,
          option: {id: number}
         ) => {
          if (option?.id === -1) {
           setSelectedOrgField(fieldId)
           const selectedCategory =
            stackholderCategoryList.find(
             (item) =>
              item.id === Number(getValues('category'))
            )
           const selectedState = getValues('state')
           const types = (await fetchOrganisationTypes({
            distributor_needed: true,
           })) as OrganizationTypeList[]
           const name =
            selectedCategory?.name?.trim().toUpperCase() ||
            ''
           const matchedType = types.find(
            (item) =>
             item.key?.trim().toUpperCase() === name ||
             item.display_name?.trim().toUpperCase() ===
              name
           )
           setOrgFormData((prev) => ({
            ...prev,
            type: matchedType?.key || '',
            type_name: matchedType?.display_name || '',
            state: selectedState || null,
           }))
           setShowOrgModal(true)
          }
         }}
        />
       )}
      </div>
      {savedOrgData && (
       <div
        className='flex items-center gap-2 mt-3 cursor-pointer w-fit'
        onClick={() => setShowPreviewModal(true)}
       >
        <i
         className='fa fa-info-circle text-[#4E83E4] text-base shrink-0'
         aria-hidden='true'
        />
        <span className='text-[#33393D] text-sm'>
         {t('userManagement.registerUser.orgReviewNotice')}
        </span>
       </div>
      )}
     </div>
     {itemConfigList.length > 0 && (
      <div className='w-full mt-10'>
       <div className='text-[#2F2F2F] text-2xl font-medium'>
        {t('myAccountPage.personalInformation.title')}
       </div>
       <div className='grid md:grid-cols-3 gap-5 w-full mt-4'>
        <GenericFormBuilder
         itemConfigList={itemConfigList}
         parentId={''}
         itemIdentifier={'personal_information'}
         excludedFields={['whatsapp_notif_enabled']}
         uploadedFileData={uploadedFileData}
         setUploadedFileData={setUploadedFileData}
         setLoader={setLoader}
         register={register}
         control={control}
         getValues={getValues}
         errors={errors}
         watch={watch}
         setValue={setValue}
        />
       </div>
      </div>
     )}
     {itemConfigList.length > 0 && (
      <div className='w-full mt-5'>
       <GenericFormBuilder
        itemConfigList={itemConfigList}
        parentId={''}
        itemIdentifier={'personal_information'}
        excludedFields={['']}
        includedFields={['whatsapp_notif_enabled']}
        uploadedFileData={uploadedFileData}
        setUploadedFileData={setUploadedFileData}
        setLoader={setLoader}
        register={register}
        control={control}
        getValues={getValues}
        errors={errors}
        watch={watch}
        setValue={setValue}
       />
      </div>
     )}
     <div className='w-full mt-10'>
      <div className='flex items-center justify-end'>
       {itemConfigList.length > 0 && (
        <>
         <Button
          type='button'
          disabled={false}
          onClick={resetForm}
          color='white'
          className='text-center py-[9px] px-6 bg-white 
                                !rounded-lg text-base text-[#4E83E4] hover:bg-[#4E83E4] font-semibold border-[#4E83E4] mr-2'
         >
          {t('common.discard')}
         </Button>
         <Button
          type='submit'
          disabled={false}
          color='blue'
          className='text-center py-[9px] px-6 bg-[#4E83E4] 
                  !rounded-lg text-base text-white font-semibold border-[#4E83E4]'
         >
          {t('registerPage.registerBtn')}
         </Button>
        </>
       )}
      </div>
     </div>
    </form>
   </div>
   <Model
    show={showOrgModal}
    showHeader={false}
    header=''
    close={() => setShowOrgModal(false)}
    modelClass='md:w-[1400px]'
    modelContainerClass='!rounded-2xl'
    modelBodyClass='p-6'
   >
    <div>
     <div className='text-lg font-semibold text-gray-800 mb-3'>
      {t('organisation.title')}
     </div>
     <OrganisationFormFields
      formData={orgFormData}
      setFormData={setOrgFormData}
      isEdit={isOrgEdit}
      isEditing={isOrgEditing}
      selfOnboarding={true}
     />

     <div className='flex justify-end gap-3 mt-6'>
      <Button
       type='button'
       color='white'
       onClick={() => setShowOrgModal(false)}
       className='px-5 py-2 border border-[#4E83E4] text-[#4E83E4]'
      >
       Cancel
      </Button>

      <Button
       type='button'
       color='blue'
       onClick={async () => {
        await handleCreateOrganisation(orgFormData)
       }}
       className='px-5 py-2 bg-[#4E83E4] text-white'
      >
       Save
      </Button>
     </div>
    </div>
   </Model>
   <OrganisationPreviewModal
    show={showPreviewModal}
    onClose={() => setShowPreviewModal(false)}
    data={savedOrgData}
    onEdit={() => {
     if (!savedOrgData) return

     setOrgFormData(savedOrgData)

     setIsOrgEdit(true)
     setIsOrgEditing(true)

     setShowPreviewModal(false)
     setShowOrgModal(true)
    }}
   />
  </>
 )
}

export default RegisterForm
